import { withPlugins, domEvents } from '@spon/plugins';

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(ScrollToPlugin, CustomEase);

function ScrollTarget({ plugins: { addEvents } }) {
	addEvents({
		'click [data-scroll]': ({ target }) => {
			const targetEl = document.querySelector(target.getAttribute('href'));
			if (!targetEl) return;

			window.scrollTo({
				top: targetEl.getBoundingClientRect().top + window.scrollY,
				behavior: 'smooth',
			});
		},
	});
}

export default withPlugins(domEvents)(ScrollTarget);
